export default "__VITE_PUBLIC_ASSET__7394ed52__"